/* global connect React Component */
import BusinessProfileCard from "./BusinessProfileCard";
import DocsDetails from "./DocsDetails";
import UserCard from "./UserCard";
import mixinFun from "../profile/mixins";

export class MyProfilePage extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("MyProfilePage");
    this.profileInfo = {
      visible:{
        "user_name": false,
        "contact_number": false,
        "user_id": false,
        "email_address": false
      },
      disabled: {
        "user_name": true,
        "contact_number": true,
        "user_id": true,
        "email_address": true
      }
    }
    this.companyInfo = {
      visible:{
        //"company_type": false
      },
      disabled:{}
    }
    let mixins = mixinFun(this);
    this.state = {
      editPane: '',
      fields: Object.except(mixins, ["links"]),
      infoData: {},
      userDetails: {},
      companyInfo: {},
      businessProfile: [],
    };
  }

  validatePersonalData(value, name) {
    switch (name) {
      case "date_of_birth": return (value).date().moment().format("DD MMM YYYY");
      case "gender": return enums.genderMaps[value];
      default: return value;
    }
  }

  getPersonalData() {
    this.api.execApi('getPersonal').then((response) => {
      console.log({response});
      let data = response.data;
      data.date_of_birth = data.date_of_birth.date().toDateTime();
      let userDetails = this.state.fields.profileInfo
        .filter(n => !["user_name"].includes(n.name))
        .reduce((o, n) => ({
          ...o, [n.label]: (this.validatePersonalData(data[n.name] ?? "", n.name))
        }), {});
      this.setState((state)=>({
        infoData: {
          ...state.infoData,
          profileInfo: data
        },
        userDetails
      }));
    }).catch((err)=>{
      console.log({err});
      this.setState((state)=>({
        infoData:{
          ...state.infoData,
          profileInfo:this.props.store.user
        }
      }));
    });
  }
  getCompanyData() {
    this.api.execApi('getCompany').then((response) => {
      let data = response.data;
      let companyInfo = this.state.fields.companyInfo
        .filter(n => ![].includes(n.name))
        .reduce((o, n) => ({
          ...o, [n.label]: (data[n.name] ?? "")
        }), {});
      this.setState((state)=>({
        infoData: {
          ...state.infoData,
          companyInfo: data
        },
        companyInfo,
      }));
    });
  }

  getBusinessData() {
    this.api.execApi('getBusiness').then((response) => {
      console.log({ response });
      let data = response.data;
      let rows = data.items || [];
      this.setState((state)=>({
        businessProfile: rows.map((row, i) => ({
          Serial_No: (i + 1),
          Partner_Name: row.director_name,
          DIN: row.din_num,
          Share_Holding: row.share_holding_pc,
        })),
      }));
    });
  }

  componentDidMount() {
    this.getPersonalData();
    this.getCompanyData();
    this.getBusinessData();
  }

  submitProfileInfo(e) {
    let payload = e.target.getData();
    payload.gender = enums.genderCode[payload.gender];
    this.api.execApi("putPersonal", payload).then(() => {
      this.getPersonalData();
    });
  }

  submitCompanyInfo(e) {
    let payload = e.target.getData();
    this.api.execApi("putCompany", payload).then(() => {
      this.getCompanyData();
    });
  }

  submitRecord(e) {
    let { editPane } = this.state;
    let methodName = "submit" + editPane.classCase();
    this[methodName] && this[methodName](e);
  }

  onEditForm(name) {
    let mapScrren = { 
      profileInfo: "/app/profile",
      companyInfo: "/app/profile/company_info",
      businessInfo:"/app/profile/business_info",
      docInfo:"/app/profile/doc_upload"
    }
    navigate(mapScrren[name]);
    //this.setState({ 'editPane': name })
  }

  render() {
    /* eslint-disable-next-line react/jsx-no-undef */
    let { pencilplus } = imagepaths;
    let { state } = this;
    let { fields, editPane, infoData = {} } = state;
    return (<AppWrapper back="Dashboard" title="My Profile" >
      <div className="content container-fluid">
        <UserCard
          title={((infoData.profileInfo && infoData.profileInfo.user_name) || '').toTitleCase()}
          userData={this.state.userDetails}
          colClass="col-md-3"
          onEdit={() => this.onEditForm('profileInfo')}
        />
        <UserCard
          title="Company Information"
          userData={this.state.companyInfo}
          colClass="col-md-4"
          dataPane="companyInfo"
          onEdit={() => this.onEditForm('companyInfo')}
        />
        <div className="container-fluid paper_container mb-4">
          <div className="card profile_card">
            <div className="card-header">
              <h5 className="card-title">Business Profile</h5>
              <button className="edit_btn" onClick={()=>this.onEditForm('businessInfo')}>
                <span className="cursor-pointer text-black">
                  <img src={pencilplus} />
                </span>
              </button>
            </div>
            <div className="card-body">
              <Row>
                <BusinessProfileCard data={this.state.businessProfile} />
              </Row>
            </div>
          </div>
        </div>
        <Row>
          <Col className="col-12 col-xl-6">
            <DocsDetails onEdit={()=>this.onEditForm('docInfo')} />
          </Col>
        </Row>
      </div>
      {/* <AppModalForm
        ref="modalform"
        title={"Edit " + (editPane.toTitleCase())}
        fields={fields[editPane]}
        data={infoData[editPane] || {}}
        open={!!editPane}
        onSubmit={(...arg) => this.submitRecord(...arg)}
        submitText="Update">
      </AppModalForm> */}
    </AppWrapper>)
  }
}

export default connect(MyProfilePage);